import BlendedSectorWeightings from "@/components/benchmark/BlendedSectorWeightings";

const PORTFOLIOS = [1] as const;

export default function MmSectorWeightings() {
  return (
    <BlendedSectorWeightings
      side="mm"
      portfolios={PORTFOLIOS}
      title="MM Sector Weightings"
      portfolioLabel={() => "MM"}
    />
  );
}
